export const blogFeed = () => {
    // Get all the category triggers
    const catTriggers = document.querySelectorAll('.js-blog-cat-trigger');
    
    if ( catTriggers ) {
        catTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                // If the trigger is already active, don't do anything
                if ( trigger.classList.contains('active') ) {
                    return;
                }

                const section = trigger.closest('.m__blog-feed');
                const cat = trigger.dataset.cat;

                // Update the active trigger
                updateActiveCatTrigger(section, cat);
    
                // Filter the blog posts based on the category
                filterBlogPosts(section, cat);
            });
        });
    }

    // Load more blog posts
    const loadMoreButtons = document.querySelectorAll('.js__load-more-blogs');

    if ( loadMoreButtons ) {
        loadMoreButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();

                loadMoreBlogPosts(button);
            });
        });
    }

    // Reset blog posts
    const resetFiltersTriggers = document.querySelectorAll('.js-blog-reset__trigger');

    if ( resetFiltersTriggers ) {
        resetFiltersTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();

                resetBlogPosts(trigger);
            });
        });
    }
};

const updateActiveCatTrigger = (section, cat) => {
    const catTriggers = section.querySelectorAll('.js-blog-cat-trigger');

    if ( catTriggers ) {
        // Update the active trigger
        catTriggers.forEach(trigger => {
            if ( trigger.dataset.cat === cat ) {
                // Add active class to the clicked trigger
                trigger.classList.add('active');
            } else {
                // Remove active class from non clicked triggers
                trigger.classList.remove('active');
            }
        });
    }
}

const filterBlogPosts = (section, cat, type = 'filter') => {
    const posts = section.querySelectorAll('.js-blog-post-card');

    if ( posts ) {
        // Hide all posts
        posts.forEach(post => {
            post.classList.add('hidden');
        });

        // Show posts that match the category
        let index = 0;

        posts.forEach(post => {
            const postCats = JSON.parse(post.dataset.cats);
            const showBlogPost = postCats.some(item => cat.includes(item));

            if ( showBlogPost ) {
                if ( index <= 8) {
                    post.classList.remove('hidden');
                }

                if ( type === 'filter') {
                    // Don't increment the index if the type is loadMore so that all the remaining posts are shown
                    index++;
                }
            }
        });

        // Show or hide the load more button
        const showLoadMoreButton = type === 'loadMore' ? false : index > 9;
        const loadMoreButtonContainer = section.querySelector('.js__load-more-blogs-btn-container');
        
        if ( showLoadMoreButton ) {
            loadMoreButtonContainer.classList.remove('hidden');
        } else {
            loadMoreButtonContainer.classList.add('hidden');
        }
    }
}

const loadMoreBlogPosts = (button) => {
    const section = button.closest('.m__blog-feed');
    const cat = section.querySelector('.js-blog-cat-trigger.active') ? section.querySelector('.js-blog-cat-trigger.active').dataset.cat : 'all';
    
    filterBlogPosts(section, cat, 'loadMore');
}

const resetBlogPosts = (trigger) => {
    const section = trigger.closest('.m__blog-feed');
    const cat = 'all';

    // Update the active trigger
    updateActiveCatTrigger(section, cat);

    // Run the filterBlogPosts function with the all category to reset these posts
    filterBlogPosts(section, cat);
}